import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCard } from '@angular/material/card';

import { CheckoutPaymentTypeAdapter } from '@spartacus/checkout/b2b/core';
import { CartNotEmptyGuard, CheckoutAuthGuard } from '@spartacus/checkout/base/components';
import { I18nModule, provideConfig } from '@spartacus/core';
import { FormErrorsModule, SpinnerModule } from '@spartacus/storefront';

import { DpPaymentTypeComponent } from './payment-type.component';

import { DpOccCheckoutPaymentTypeAdapter } from '../../adapters';

@NgModule({
  imports: [CommonModule, I18nModule, ReactiveFormsModule, FormErrorsModule, SpinnerModule, MatCard],
  providers: [
    {
      provide: CheckoutPaymentTypeAdapter,
      useClass: DpOccCheckoutPaymentTypeAdapter
    },
    provideConfig({
      cmsComponents: {
        CheckoutPaymentType: {
          component: DpPaymentTypeComponent,
          guards: [CheckoutAuthGuard, CartNotEmptyGuard]
        }
      }
    })
  ],
  declarations: [DpPaymentTypeComponent],
  exports: [DpPaymentTypeComponent]
})
export class DpPaymentTypeModule {}
